import { render, staticRenderFns } from "./form-related.vue?vue&type=template&id=5fecf12c"
import script from "./form-related.vue?vue&type=script&lang=js"
export * from "./form-related.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports